 <template>

   <!--意见反馈弹窗-->
   <div class="alert-box">
     <p v-on:click="closeFun" class="mask"></p>
     <div class="alert-box-form border-box">
       <img v-on:click="closeFun" class="icon_close" src="../assets/icon_close.png" />
       <p class="font28 cor6 tc">您的意见是我们前进的动力</p>
       <textarea class="font24 cor6 border-box" v-model="feedbackInfo" placeholder="请写下您的宝贵意见"  />
       <input class="font24 cor6 border-box" v-model="feedbackPhone" type='number' placeholder="您的手机号码，便于我们联系您（必填）" />
       <p @click="uploadFeed" class="btn_submit font28 corF tc">提交</p>
     </div>
   </div>

</template>

<script>

import { mapState, mapMutations } from 'vuex'
import {getFeedback} from "@/service/getData";
import {setStore, getStore, removeStore} from '@/config/mUtils'
import D from '@/wc-messagebox'

export default {
    data(){
        return{
          userInfo: {},
          feedbackClose:0,
          feedbackInfo:'',//反馈内容
          feedbackPhone:'',//反馈人电话
          fsuccess: false,
        }
    },
    mounted(){

    },
    computed: {

    },
    methods: {
      closeFun:function(){
        this.$emit('child-Feedback',this.feedbackClose);
      },
      async uploadFeed(){
        this.userInfo = getStore("userInfo");
        if(this.fsuccess == true){
            return;
        }
        if (this.feedbackInfo == undefined || this.feedbackInfo == '' || this.feedbackInfo == null) {
          this.$toast('请先输入内容');
          this.fsuccess = false;
          return
        }
        if (this.feedbackPhone == undefined || this.feedbackPhone == '' || this.feedbackPhone == null) {
          this.$toast('请输入联系电话');
          this.fsuccess = false;
          return
        }
        if (!(/^1[34578]\d{9}$/.test(this.feedbackPhone))) {
          this.$toast('手机号码格式不正确');
          this.fsuccess = false;
          return
        }
        let res = await getFeedback({
          openid: this.userInfo.openid,
          title: '【' + this.feedbackPhone+ '】' + this.feedbackInfo
        });
        if (res.errcode == '00000') {
          this.$toast('提交成功')
          this.feedbackInfo=''
          this.feedbackPhone=''
          this.fsuccess = true;
          this.closeFun();
        }else {
          this.fsuccess = false;
          this.$toast(res.errmsg)
        }
      },

    }
}
</script>

<style scoped>

  @import '../style/alert';

</style>



// WEBPACK FOOTER //
// src/components/AlertFeedback.vue